import CopyButton from "./CopyButton";

const BankDetails = () => {
  return (
    <div className="bg-gray-100 rounded-lg p-4 text-left space-y-3 text-gray-800 border border-gray-200 shadow-sm">
      <p className="flex justify-between items-center">
        <span className="font-semibold">Bank Name:</span>
        <span className="flex items-center gap-2">
          <CopyButton valueToCopy="Commonwealth Bank LTD" />
          <span>Commonwealth Bank LTD</span>
        </span>
      </p>
      <p className="flex justify-between items-center">
        <span className="font-semibold">Bank Address:</span>
        <span className="flex items-center gap-2">
          <CopyButton valueToCopy="Mackey Street P.O Box SS-5541" />
          <span>Mackey Street P.O Box SS-5541 </span>
        </span>
      </p>

      <p className="flex justify-between items-center">
        <span className="font-semibold">Branch Number:</span>
        <span className="flex items-center gap-2">
          <CopyButton valueToCopy=" 21104 Marsh Harbour Abaco" />
          <span>21104 Marsh Harbour Abaco </span>
        </span>
      </p>
      <p className="flex justify-between items-center">
        <span className="font-semibold">Account Holder Name:</span>
        <span className="flex items-center gap-2">
          <CopyButton valueToCopy="Lux First Choice Cars" />
          <span>Lux First Choice Cars</span>
        </span>
      </p>
      <p className="flex justify-between items-center">
        <span className="font-semibold">Account Number:</span>
        <span className="flex items-center gap-2">
          <CopyButton valueToCopy="1042016520 " />
          <span>1042016520 </span>
        </span>
      </p>
      <p className="flex justify-between items-center">
        <span className="font-semibold">SWIFT Code:</span>
        <span className="flex items-center gap-2">
          <CopyButton valueToCopy="COMWBSNS" />
          <span>COMWBSNS</span>
        </span>
      </p>
    </div>
  );
};

export default BankDetails;
